var s = (a, r, e) => new Promise((c, l) => {
  var n = (t) => {
    try {
      i(e.next(t));
    } catch (o) {
      l(o);
    }
  }, f = (t) => {
    try {
      i(e.throw(t));
    } catch (o) {
      l(o);
    }
  }, i = (t) => t.done ? c(t.value) : Promise.resolve(t.value).then(n, f);
  i((e = e.apply(a, r)).next());
});
import { selfAxios as m } from "@oppein/op-utils";
function A(a) {
  return s(this, null, function* () {
    return yield m.get(
      `/bsplatform/commodity/getAllMaterial/${a.classificationId}`
    );
  });
}
export {
  A as getGetAllMaterial
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/bsplatform/commodity/getAllMaterial/get.js
// module id = 1750
// module chunks = 41